pageId = 'page-email-join'

$ ->
  tower.initMobileVerification $("##{pageId}")
